import { ICampaign } from "../Campaign/Campaign";
import { ICanvasBannerPlaceholder } from "./CanvasBannerPlaceholder";
import { ICanvasContentParameter } from "./CanvasContentParameter";
import { IFormatVersion } from "./FormatVersion";

export interface ICanvasContent {
    id?: string;
    bannerPlaceholderId?: string;
    bannerPlaceholder?: ICanvasBannerPlaceholder;
    formatVersionId?: string;
    formatVersion?: IFormatVersion;
    campaignId?: number;
    campaign?: ICampaign;
    parameters?: ICanvasContentParameter[]
}

export class CanvasContent implements ICanvasContent {
    id?: string;
    bannerPlaceholderId?: string;
    bannerPlaceholder?: ICanvasBannerPlaceholder;
    formatVersionId?: string;
    formatVersion?: IFormatVersion;
    campaignId?: number;
    campaign?: ICampaign;
    parameters?: ICanvasContentParameter[]

    constructor();
    constructor(obj: ICanvasContent);
    constructor(obj?: ICanvasContent) {
        this.id = obj?.id || undefined;
        this.bannerPlaceholderId = obj?.bannerPlaceholderId || undefined;
        this.bannerPlaceholder = obj?.bannerPlaceholder || undefined;
        this.formatVersionId = obj?.formatVersionId || undefined;
        this.formatVersion = obj?.formatVersion || undefined;
        this.campaignId = obj?.campaignId || undefined;
        this.campaign = obj?.campaign || undefined;
        this.parameters = obj?.parameters || [];
	}
}
